import './src/styles/global.css'
export const onInitialClientRender = () => {
    window.scrollTo(0, 0);
};
